import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { Idle } from "@ng-idle/core";
import { TranslateModule } from "@ngx-translate/core";
import { AuthenticationService } from "@shared/services/authentication.service";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@Component({
  selector: "app-logout",
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule, ButtonModule, TranslateModule],
  templateUrl: "./logout.component.html",
  providers: [Idle, ConfirmationService],
})
export class LogoutComponent {
  isMenuLogoutOpen = false;

  @Output() menuOpenEmitter = new EventEmitter<boolean>();
  constructor(
    private confirmationService: ConfirmationService,
    public authService: AuthenticationService,
    public idle: Idle
  ) {}

  confirmationPopup() {
    this.confirmationService.confirm({
      accept: () => {
        this.authService.logout();
        this.idle.stop();
        this.menuOpenEmitter.emit(false);
      },
      reject: () => {
        this.idle.watch();
      },
    });
  }
}
